// tslint:disable-next-line:import-spacing
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {MagicLinkModel, TabModel, ToolItemCollection} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand, PlatformCommandResponse} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {FuseSidebarService} from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {select, Store} from '@ngrx/store';
import {getCurrentToast} from '@shared/store/toast/toast-selectors';
import {DismissToastSuccessAction} from '@shared/store/toast/toast-actions';
import {IToastState} from '@shared/store/toast/toast-reducer';
import {
  SetActivityFeedAction,
  SetCurrentRightSideComponentAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {getCurrentFilterId} from '@shared/store/selectors/conceptual-graph.selectors';
import {ClearConceptualGraphFilter, LoadConceptualGraphFilter} from '@shared/store/actions/conceptual-graph.actions';
import {ConceptualGraphState} from '@shared/store/reducers/conceptual-graph.reducer';
import {ConceptualGraphService} from '@shared/services/conceptual-graph/conceptual-graph.service';
import {getCurrentPlatformLink, ParticleState} from '@shared/store/reducers/particle.reduer';
import {DialogModel} from '@shared/models/dialog.model';
import {ConceptualGraph} from '@shared/models/conceptual-graph/conceptual-graph.model';
import {ProjectService} from "@features/projects/services/project-service";
import {getCurrentProject, ProjectState} from "@features/projects/store/reducers/projects.reducer";

@Injectable({
  providedIn: 'root',
})
export class ScenarioDetailsHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  private sourceType: string;
  private updateCommandName: string;
  private currentProjectId: string;
  constructor(private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private platformSidebarService: PlatformSidebarService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private conceptualGraphStore: Store<ConceptualGraphState>,
              private sidebarService: FuseSidebarService,
              private toastStore: Store<IToastState>,
              private conceptualGraphService: ConceptualGraphService,
              private projectStore: Store<ProjectState>
  ) {
    this.projectStore.select(getCurrentProject).pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentProject => {
      // console.log(`got current project:`, currentProject);
      if (currentProject && currentProject.ProjectId) {
        this.currentProjectId = currentProject.ProjectId;
        console.log(this.currentProjectId);
      }
    });
  }

  executeCommand(command: PlatformCommand) {
    console.log('[ITC-platform-command] onPlatformTool Handler Command', command);

    if (this.magicLinkModel.fieldValues['ScenarioType']) {
      command.fieldValues['ScenarioType'] = this.magicLinkModel.fieldValues['ScenarioType'];
    }

    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this, null);
        return;
      }
    }
    switch (command.name) {
      case 'ExportGraphAsPdfCommand':
        const fileName = command.fieldValues['FileName'];
        this.conceptualGraphService.exportAsPdf(fileName);
        this.executeCommandToApi(command);
        break;
      case 'FilterScenarioConceptualGraphCommand':
        this.openFilterDialog(command);
        break;
      case 'SaveScenarioConceptualGraphFilterCommand':
        this.conceptualGraphStore
          .pipe(select(getCurrentFilterId))
          .pipe(take(1))
          .subscribe(res => {
            command.fieldValues['FilterId'] = res;
            this.executeCommandToApi(command);
            delete command.fieldValues['FilterName'];
            delete command.fieldValues['FilterDescription'];
          });
        break;
      case 'ExportDataTemplateCommand':
      case 'ExportDataTemplateV2Command':
        command.fieldValues['SelectedReportId'] = command.fieldValues['ItemId'];
        this.executeCommandToApi(command);
      case 'InformationBar':
        break;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  private openFilterDialog(command: PlatformCommand) {
    let currentFilterId = null;
    this.conceptualGraphStore.pipe(select(getCurrentFilterId)).subscribe(res => {
      currentFilterId = res;
    });
    if (currentFilterId) {
      let title = 'Clear Entity Chart Filter';
      if (command.fieldValues['ClearFilterDialogTitle']) {
        title = command.fieldValues['ClearFilterDialogTitle'];
      }
      this.dialogService.showYesNoDialog(title, 'Are you sure to clear current filter?')
        .subscribe(state => {
          if (state && state.action === 'OK') {
            this.fuseSplashScreenService.show();
            this.conceptualGraphStore.dispatch(new ClearConceptualGraphFilter(this.conceptualGraphService, currentFilterId));
            this.updateButton('Filter');
          }
        });
    } else {
      this.showConceptualGraphFilterDialog(command);
    }
  }

  private updateButton(title?: string) {
    const toolItems = this.magicLinkModel.breadcrumbBar.items;
    toolItems.forEach(item => {
      if (item.id === 'Default') {
        item.commands.forEach(cmd => {
          if (cmd.name === 'FilterScenarioConceptualGraphCommand') {
            cmd.title = title ?? 'Clear Filter';
          }
        });
      }
    });
    const toolItemCollection = new ToolItemCollection();
    toolItemCollection.items = toolItems;
    const payload = {id: 'ToolItemsComponent', toolItems: toolItemCollection};
    this.magicLinkModelValueChanged.emit(payload);
  }

  private showConceptualGraphFilterDialog(command: PlatformCommand) {
    const dialogModel = DialogModel.create('Filters', 'ScenarioConceptualGraphFilterDialogComponent', {
        api: command.api,
        sourceType: command.fieldValues['SourceType'],
        sectionHeaders: command.fieldValues['SectionHeaders'],
        note: 'filter',
        ...command.fieldValues
      },
      '650px',
      '1050px');
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
      if (state && state.action === 'OK') {
        command.fieldValues['FieldConditions'] = state.data.input.fieldConditions;
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
          if (res && res.fieldValues) {
            this.loadConceptualGraphFilter(res);
          }
        });
      }
    });
  }

  private loadConceptualGraphFilter(res: PlatformCommandResponse) {
    const conceptualGraph = res.fieldValues['ConceptualGraph'] as ConceptualGraph;
    const flyWeightId = res.fieldValues['FlyWeightId'] as string;
    const filterId = res.fieldValues['FilterId'] as string;
    this.conceptualGraphStore.dispatch(new LoadConceptualGraphFilter(this.conceptualGraphService.api,
      this.conceptualGraphService.projectId, flyWeightId, filterId, conceptualGraph));
    this.updateButton();
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if ( this.handleByFieldDefinition($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
    this.sourceType = selectedTab.tabData['SourceType'];
    this.updateCommandName = selectedTab.tabData['UpdateCommandName'] ?? 'UpdateScenarioEntityCommand';

    const isStepByStepEnabled = this.magicLinkModel.homeSideBar?.items
      ?.some(item => item.componentName === 'SpreadsheetGuidedTourComponent');

    if (isStepByStepEnabled) {
      // Step-by-Step Process leads the sidebar for as long as step-by-step is enabled — don't
      // let the per-tab Details auto-open below bump it.
      this.platformSidebarStore.dispatch(
        new SetCurrentRightSideComponentAction(
          {component: 'SpreadsheetGuidedTourComponent', data: {isUserAction: false}, componentInfo: {id: 'SpreadsheetGuidedTourComponent'}}));
    } else if (selectedTab.tabData?.DetailsHelpId &&
      ((!this.magicLinkModel.fieldValues.hasOwnProperty('FlowId') || this.magicLinkModel.fieldValues.FlowId == null) && (!this.magicLinkModel.fieldValues.hasOwnProperty('NodeId') || this.magicLinkModel.fieldValues.NodeId == null))) {
      // ! [MAGIC-BAR-AUTO-OPEN]
      this.platformSidebarStore.dispatch(
        new SetCurrentRightSideComponentAction(
          {component: 'HelpNotesComponent', data: {isUserAction: false}, componentInfo: {id: 'HelpNotesComponent'}}));
    }
    // update commands with selected tab id
    this.subscribeForToastNotification();
  }

  destroy() {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarService.hideSidebarIcon('ITC Scenario');
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private executeCommandToApi(command: PlatformCommand, doNotRedirect?) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      command.projectId = '[PROJECT_ID]';
      command.fieldValues['ProjectId'] = this.currentProjectId;
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }

          if (commandResponse.fieldValues['RedirectUrl'] && !doNotRedirect) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];

            this.downloadFile(fileId, fileName);
          }

          if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel'],
              magicLinkModel: this.magicLinkModel
            });
          }
          if (commandResponse.fieldValues['LoadFilter']) {
            this.loadConceptualGraphFilter(commandResponse);
            return;
          }
          if(commandResponse.fieldValues['IsAutomaticNavigation'] !== null) {
            this.magicLinkModelValueChangedHandler({
              isAutomaticNavigation: commandResponse.fieldValues['IsAutomaticNavigation']
            })
          }
          this.invalidateSubject.invalidate();
          this.invalidateSubject.invalidate('CardHolder');
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private subscribeForToastNotification() {
    this.toastStore.pipe(select(getCurrentToast), takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res && res.type === 'Scenario') {
        console.log('Toast');
        const scenarioId = this.magicLinkModel.tabBar.tabs.filter(t => t.id === 'ScenarioEntities')[0]?.tabData?.ScenarioId;
        if (scenarioId) {
          const command = new PlatformCommand('CreateScenarioDetailLinkCommand', 'SpreadsheetApi');
          command.setValue('ScenarioId', scenarioId);
          this.executeCommandToApi(command, true);
        }
        this.toastStore.dispatch(new DismissToastSuccessAction(res));
      }
    });
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CommandName':
          // Handle the Command
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleAction($event): boolean {
    console.log('Inside handleAction');
    if ($event && $event.action) {
      const item = $event.item;
      const command = this.magicLinkModel.additionalCommands[$event.action.id];
      if (command) {
        command.fieldValues['ItemId'] = item.id;
        this.executeCommand(command);
        return true;
      }
      switch ($event.action.id) {
        case 'Edit':
          this.edit($event);
          return true;
        case 'ShowActivity':
          this.showActivity($event.item);
          return true;
        case 'Delete':
          this.deleteItem($event);
          return true;
      }
    } else if ($event.name && $event.api) {
      let command = $event;
      const additionalCommand = this.magicLinkModel.additionalCommands[$event.name];
      if (additionalCommand) {
        additionalCommand.fieldValues = {
          ...additionalCommand.fieldValues,
          ...command.fieldValues
        };
        command = additionalCommand;
      }
      if (command) {
        command.projectId = '[PROJECT_ID]';
        command.fieldValues['ProjectId'] = this.currentProjectId;
        this.fuseSplashScreenService.show();
        this.commandService.executePlatformCommand(command).pipe(take(1))
          .subscribe(response => {
            this.commandService.handleResponse(response);
          }, error => {
            this.fuseSplashScreenService.hide();
          });
      }
    }
    return false;
  }

  private showActivity(item: any) {
    const referenceCode = item.id;
    const title = item.cells['EntityName'].value;
    const activityInfo = {type: 'ReferenceCode', 'id': referenceCode, 'title': title, isDefault: false, isUserAction: true};
    this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  private handleByFieldDefinition($event): boolean {
    console.log('Inside handleByFieldDefinition');
  if (!$event.fieldDefinition) {
    return false;
  }
    const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
    if (command) {
      command.fieldValues['ItemId'] = $event.item.id;
      this.executeCommand(command);
      return true;
    }
    return false;
  }

  private updateScenarioEntity($event) {
    const item = {id: $event.item.id, fieldValues: {}};
    const value = $event.item.cells[$event.fieldDefinition.key].value;
    item.fieldValues[$event.fieldDefinition.key] = value;
    const command = new PlatformCommand(this.updateCommandName, 'SpreadsheetApi');
    command.fieldValues['ItemId'] = $event.item.id;

    command.fieldValues['FieldKey'] = $event.fieldDefinition.key;
    command.fieldValues['FieldHeader'] = $event.fieldDefinition.header;
    command.fieldValues[$event.fieldDefinition.key] = value;
    this.executeCommandToApi(command);
  }

  private edit($event) {
    this.openEditor($event);
  }

  private deleteItem($event){
    const deleteScenarioEntityCommand = new PlatformCommand('DeleteScenarioEntityCommand', 'SpreadsheetApi');
    const scenarioType = $event.item.cells['ScenarioType'].value;
    deleteScenarioEntityCommand.fieldValues['ScenarioEntityModelId'] = $event.item.id;
    deleteScenarioEntityCommand.fieldValues['FieldKey'] = $event.fieldDefinition.key;
    deleteScenarioEntityCommand.fieldValues['FieldHeader'] = $event.fieldDefinition.header;
    if ('ScenarioCalculationModelId' in $event.item.cells) {
      var scenarioCalculationModelId = $event.item.cells['ScenarioCalculationModelId'].value;
      deleteScenarioEntityCommand.fieldValues['ScenarioCalculationModelId'] = scenarioCalculationModelId;
    }
    deleteScenarioEntityCommand.fieldValues['ScenarioType'] = scenarioType;
    this.executeCommandToApi(deleteScenarioEntityCommand);
  }

  private openEditor($event) {
    const originalValue = $event.item.cells[$event.fieldDefinition.key]?.value;
    this.dialogService.showCellEditorDialog($event.item, $event.fieldDefinition, '400px', '1500px', this.sourceType).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      console.log('After close state: ', state);
      if (state?.action === 'OK') {
        this.updateScenarioEntity($event);

        const metaData = $event.item.cells[$event.fieldDefinition.key]?.metaData;
        if (metaData?.applyToAllInvalid && metaData?.BulkUpdateCommand) {
          const bulkCommand = JSON.parse(JSON.stringify(metaData.BulkUpdateCommand));
          bulkCommand.fieldValues['SelectedDate'] = $event.item.cells[$event.fieldDefinition.key].value;
          this.executeCommandToApi(bulkCommand);
        }
      } else {
        // change back to original value
        $event.item.cells[$event.fieldDefinition.key].value = originalValue;
        this.invalidateSubject.invalidate();
      }
    });
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }
}
